/**
 * @generated SignedSource<<63a4c6e6e8b52c5bae884c6a4622c9a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildStatus = "ABORTED" | "COMPLETED" | "CREATED" | "ERRORED" | "EXECUTING" | "FAILED" | "NEEDS_APPROVAL" | "TRIGGERED" | "%future added value";
export type PermissionType = "ADMIN" | "NONE" | "READ" | "WRITE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RepositoryBuildList_repository$data = {
  readonly builds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly clockDurationInSeconds: number | null;
        readonly id: string;
        readonly status: BuildStatus;
        readonly " $fragmentSpreads": FragmentRefs<"BuildCard_build">;
      };
    }>;
  };
  readonly id: string;
  readonly name: string;
  readonly owner: string;
  readonly platform: string;
  readonly viewerPermission: PermissionType;
  readonly " $fragmentSpreads": FragmentRefs<"CreateBuildDialog_repository">;
  readonly " $fragmentType": "RepositoryBuildList_repository";
};
export type RepositoryBuildList_repository$key = {
  readonly " $data"?: RepositoryBuildList_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryBuildList_repository">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "branch"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryBuildList_repository",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerPermission",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateBuildDialog_repository"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "branch",
          "variableName": "branch"
        },
        {
          "kind": "Literal",
          "name": "last",
          "value": 50
        }
      ],
      "concreteType": "RepositoryBuildsConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RepositoryBuildEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Build",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clockDurationInSeconds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "BuildCard_build"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
})();

(node as any).hash = "31151821bb66c2beb5f19170da665e18";

export default node;
